import { FormProvider, FormContext } from "./FormContext";
import React, {
  useState,
  useEffect,
  setState,
  useContext,
  useRef,
  map,
} from "react";
import { Button, ButtonGroup } from "@chakra-ui/react";
import { Heading } from "@chakra-ui/react";
import { ChakraProvider } from "@chakra-ui/react";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";

import "./styles.css";

function getMonday(d) {
  d = new Date(d);
  var day = d.getDay(),
    diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
  return new Date(d.setDate(diff));
}
function getFriday(d) {
  d = new Date(d);
  var day = d.getDay(),
    diff = d.getDate() + (5 - day) + (day == 6 ? +6 : 0); // adjust when day is saturday
  return new Date(d.setDate(diff));
}
function DayBox({ day, available, onDataChange }) {
  var classname = "day middle";
  if (day === "M") {
    classname = "day";
  }
  const numAvailable = available.length;
  const handleClick = (e) => {
    console.log("clicked" + day);
    onDataChange(day);
    e.preventDefault();
  };
  //get how many appts available on this day
  //button to next step
  return (
    <div className={classname}>
      <Heading as="h3">{day}</Heading>
      <br />
      <p>{numAvailable} appointments available</p>
      <br />
      <Button onClick={handleClick} colorScheme="blue">
        View
      </Button>
    </div>
  );
}
function DayTitle({ day }) {
  var Title = "";
  switch (day) {
    case "M":
      Title = "Monday";
      break;
    case "T":
      Title = "Tuesday";
      break;
    case "W":
      Title = "Wednesday";
      break;
    case "Th":
      Title = "Thursday";
      break;
    case "F":
      Title = "Friday";
      break;
    default:
      Title = "";
      break;
  }
  return <>{Title}</>;
}

export default function App() {
  const available = [
    {
      day: "M",
      time: "10:00",
    },
    {
      day: "M",
      time: "11:00",
    },
    {
      day: "T",
      time: "10:00",
    },
    {
      day: "W",
      time: "10:00",
    },
    {
      day: "F",
      time: "10:00",
    },
    {
      day: "F",
      time: "11:00",
    },
  ];
  const today = new Date();
  const month = today.getMonth() + 1;
  const start = getMonday(today).getDate();
  const end = getFriday(today).getDate();
  //console.log("Type of available in app:", Array.isArray(available), available);

  const [step, setStep] = useState(1); // State to manage the current step of the form
  const [formData, setFormData] = useState({
    day: "",
    time: "",
    firstname: "",
    lastname: "",
    phone: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const nextStep = () => {
    setStep(step + 1);
  };

  const prevStep = () => {
    setStep(step - 1);
    if (step == 2) setDayState(null);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStep(4);
  };
  const [dayState, setDayState] = useState(null);
  const [timeState, setTimeState] = useState(null);
  const [firstName, setFirstName] = useState("First Name");
  const [lastName, setLastName] = useState("Last Name");
  const [phone, setPhone] = useState("Phone Number");

  const handleChildData = (data) => {
    console.log(data);
    setDayState(data);
  };
  useEffect(() => {
    console.log(dayState);
    if (dayState !== null && step < 2) {
      setStep(2);
    }
  }, [dayState]);
  const timeRef = useRef(null);
  const handleClick2 = (value) => {
    console.log(value);
    setTimeState(value);
    setStep(3);
  };
  /*
  useEffect(() => {
    console.log(timeState);
    if (timeState !== null) {
      setStep(3);
    }
  }, [timeState]);*/
  const resetInput = (e) => {
    e.target.value = "";
  };

  return (
    <ChakraProvider>
      <div className="App">
        <form onSubmit={handleSubmit}>
          {step === 1 && (
            <>
              <Heading as="h2">
                Week of {month}/{start} - {month}/{end}
              </Heading>
              <Heading as="h1">Select a Day</Heading>
              <br />
              <div>
                <DayBox
                  day="M"
                  available={available.filter((days) => days.day == "M")}
                  onDataChange={handleChildData}
                />
                <DayBox
                  day="T"
                  available={available.filter((days) => days.day == "T")}
                  onDataChange={handleChildData}
                />
                <DayBox
                  day="W"
                  available={available.filter((days) => days.day == "W")}
                  onDataChange={handleChildData}
                />
                <DayBox
                  day="Th"
                  available={available.filter((days) => days.day == "Th")}
                  onDataChange={handleChildData}
                />
                <DayBox
                  day="F"
                  available={available.filter((days) => days.day == "F")}
                  onDataChange={handleChildData}
                />
              </div>
            </>
          )}
          {step === 2 && (
            <div className="step2">
              <Heading as="h2">
                <DayTitle day={dayState} /> Time Slots :
              </Heading>
              <ul className="timeOptions">
                {available
                  .filter((days) => days.day == dayState)
                  .map((bookings) => (
                    <li
                      key={bookings.time}
                      ref={timeRef}
                      onClick={() => handleClick2(bookings.time)}
                    >
                      {bookings.time}
                    </li>
                  ))}
              </ul>
              <Button colorScheme="blue" onClick={prevStep}>
                {" "}
                Back
              </Button>
            </div>
          )}
          {step === 3 && (
            <div className="step3">
              <Heading as="h2">
                <DayTitle day={dayState} /> at {timeState}
              </Heading>
              <div className="formGroup">
                <input
                  type="text"
                  value={firstName}
                  onFocus={(e) => resetInput(e)}
                  onChange={(e) => setFirstName(e.target.value)}
                />
                <input
                  type="text"
                  value={lastName}
                  onFocus={(e) => resetInput(e)}
                  onChange={(e) => setLastName(e.target.value)}
                />
                <PhoneInput
                  defaultCountry="us"
                  value={phone}
                  onFocus={(e) => resetInput(e)}
                  onChange={(phone) => setPhone(phone)}
                />
                <br />
                <Button colorScheme="blue" type="submit">
                  Book Appointment
                </Button>
              </div>
              <Button colorScheme="blue" onClick={prevStep}>
                {" "}
                Back
              </Button>
            </div>
          )}
          {step === 4 && (
            <div className="step4">
              <Heading as="h2">Appointment Booked</Heading>
              <div className="apptCard">
                <Heading as="h4">
                  <DayTitle day={dayState} /> at {timeState}
                </Heading>
                <Heading as="h4">
                  Name: {firstName} {lastName}
                </Heading>
                <Heading as="h4">Phone: {phone}</Heading>
              </div>
              <Button colorScheme="blue" onClick={prevStep}>
                {" "}
                Back
              </Button>
            </div>
          )}
        </form>
      </div>
    </ChakraProvider>
  );
}
